import { createContext, useContext } from 'react';

export const LeadModalContext = createContext({
  openLeadModal: () => {},
  closeLeadModal: () => {},
  notifyLeadSubmitted: () => {},
  markEngaged: () => {},
  isCompact: false
});

export function useLeadModal() {
  return useContext(LeadModalContext);
}
